import { createAction, props } from '@ngrx/store';

import { UpdateUserAccess, UserAccess } from '../../models/access';
import { BackOfficeUser } from '../../models/backOfficeUser';
import { CMSAssociationResult, CrmUser } from '../../models/installer';

export class AdminActions {
    static readonly LOAD_INSTALLERS_CMS_ASSOCIATION = 'LOAD_INSTALLERS_CMS_ASSOCIATION';
    static readonly LOAD_USER_ACCESS = 'LOAD_USER_ACCESS';
    static readonly UPDATE_USER_ACCESS = 'UPDATE_USER_ACCESS';
    static readonly REMOVE_USER_ACCESS = 'REMOVE_USER_ACCESS';
    static readonly SET_SELECTED_INSTALLER = 'SET_SELECTED_INSTALLER';
    static readonly SET_CURRENT_BACKOFFICE_USER_INFO = 'SET_CURRENT_BACKOFFICE_USER_INFO';
}

export const loadInstallersCmsAssociation = createAction(
    AdminActions.LOAD_INSTALLERS_CMS_ASSOCIATION,
    props<{ cmsAssociationResults: CMSAssociationResult[] }>(),
);

export const loadUserAccess = createAction(AdminActions.LOAD_USER_ACCESS, props<{ users: UserAccess[] }>());

export const updateUserAccess = createAction(
    AdminActions.UPDATE_USER_ACCESS,
    props<{ userAccess: UpdateUserAccess }>(),
);

export const removeUserAccess = createAction(AdminActions.REMOVE_USER_ACCESS, props<{ userAccess: string }>());

export const setSelectedInstaller = createAction(AdminActions.SET_SELECTED_INSTALLER, props<{ installer: CrmUser }>());

export const setCurrentBackOfficeUserInfo = createAction(
    AdminActions.SET_CURRENT_BACKOFFICE_USER_INFO,
    props<{ user: BackOfficeUser }>(),
);
